import React, { Component } from 'react';
import { Redirect } from 'react-router-dom';
import { PostData } from '../../services/PostData';
import { GetData } from '../../services/GetData';
import {
	Row,
	Col,
	Button,
	Card,
	CardHeader,
	CardBody,
	FormGroup,
	Label,
} from 'reactstrap';
import $ from 'jquery';
import ManagePage from '../../views/ManagePage/';
import ManageStaffPage from '../../views/ManageStaffPage/';

class AddGroupMember extends Component {

	/** set property value **/
	constructor(props) {
		super(props);
		this.state = {
			id: '',
			group: this.props.match.params.id,
			groupname: '',
			_message: '',
			alertClass: '',
			cladata: [],
			groups: [],
			employee: [],
			isadd: 1,
			sec: [],
			acyear: '',
			accyear: [],
			sections: [],
			depart: [],
			students: [],
			view: 0,
			department: '',
			_redirect: false,
			member: [],
			studmember: [],
			staffmember: [],
			staff: [],
			viewbtn: true
		}
		this.onChange = this.onChange.bind(this);
		this.onSubmit = this.onSubmit.bind(this);
		this.onClassChange = this.onClassChange.bind(this);
		this.onSectionChange = this.onSectionChange.bind(this);
		this.onDepChange = this.onDepChange.bind(this);
	}

	onChkAllStaffChange(e) {

		if (e.target.checked) {
			$(".chkstaff").prop("checked", true);
			this.state.staff = [];
			if (this.state.type == 'staff') {
				for (var i = 0; i < this.state.employee.length; i++) {
					if (this.state.staffmember.length > 0) {
						this.checkselectstaffmember(this.state.employee[i].empcode);
					} else {
						this.state.staff.push({ "empcode": this.state.employee[i].empcode });
					}
				}
			}
		} else {
			$(".chkstaff").prop("checked", false);
			this.state.staff = [];
		}
	}

	onChkStaffChange(empcode, e) {

		if (e.target.checked) {
			var index = this.state.staff.findIndex(function (obj) {
				return (obj.empcode == empcode);
			});
			if (index === -1) {
				this.state.staff.push({ "empcode": empcode });
			}
		} else {
			var index = this.state.staff.findIndex(function (obj) {
				return (obj.empcode == empcode);
			});
			if (index != -1) {
				this.state.staff.splice(index, 1);
			}
		}
	}

	checkselectstaffmember(empcode) {

		var index = this.state.staffmember.findIndex(function (obj) {
			return (obj.employee == empcode);
		});
		if (index === -1) {
			this.state.staff.push({ "empcode": empcode });
		}
	}

	onChkChange(regno, e) {

		if (e.target.checked) {
			var index = this.state.member.findIndex(function (obj) {
				return (obj.regno == regno);
			});
			if (index === -1) {
				this.state.member.push({ "regno": regno });
			}
		} else {
			var index = this.state.member.findIndex(function (obj) {
				return (obj.regno == regno);
			});
			if (index != -1) {
				this.state.member.splice(index, 1);
			}
		}
	}

	onChkAllChange(e) {

		if (e.target.checked) {
			$(".chk").prop("checked", true);
			this.state.member = [];
			if (this.state.type == 'student') {
				for (var i = 0; i < this.state.students.length; i++) {
					if (this.state.studmember.length > 0) {
						this.checkselectmember(this.state.students[i].regno);
					} else {
						this.state.member.push({ "regno": this.state.students[i].regno });
					}
				}
			}
		} else {
			$(".chk").prop("checked", false);
			this.state.member = [];
		}
	}

	checkselectmember(regno) {

		var index = this.state.studmember.findIndex(function (obj) {
			return (obj.student == regno);
		});
		if (index === -1) {
			this.state.member.push({ "regno": regno });
		}
	}

	onDepChange(e) {

		this.state.department = e.target.value;
		this.setState({ view: 0, staff: [] });
		$("#chkallstaff").prop("checked", false);
		$(".chkstaff").prop("checked", false);
	}

	onSectionChange(e) {

		this.state.section = e.target.value;
		this.setState({ view: 0 });
		$("#chkall").prop("checked", false);
		$(".chk").prop("checked", false);
	}

	onClassChange(e) {
		this.state.class = e.target.value;
		this.setState({ view: 0 });
		$("#chkall").prop("checked", false);
		$(".chk").prop("checked", false);
		this.getsection(this.state.class);
	}

	onChange(e) {
		this.setState({ [e.target.name]: e.target.value });
		this.setState({ view: 0, member: [], section: '', class: '', department: '' });
		$("#class").val('');
		$("#section").val('');
		$("#dep").val('');
		$("#chkall").prop("checked", false);
		$(".chk").prop("checked", false);
	}

	onSubmit(e) {
		e.preventDefault();
		$("#showLoader").show();
		PostData('group/addgroupmember', this.state).then((result) => {
			$("#showLoader").hide();
			let responseJson = result;
			if (responseJson.status == '1') {
				this.setState({
					_message: 'Group Member Added Successfully!..',
					alertClass: 'alert alert-success',
					view: 0,
					member: [],
					students: [],
				});
				document.getElementById("stcatform").reset();
			}
			else {
				this.setState({
					_message: 'Error',
					alertClass: 'alert alert-danger'
				});
			}
		});
	}

	componentDidMount() {

		this.getdata();
		this.getclass();
		this.getacyear();
		this.getdepartment();
	}

	getdepartment() {

		GetData('department/getdepartment').then((result) => {
			let responseJson = result;
			if (responseJson) {
				this.setState({
					depart: responseJson
				});
			}
		});
	}

	/** get Class **/
	getclass() {

		GetData('classs/getclass').then((result) => {
			let responseJson = result;
			if (responseJson) {
				this.setState({
					cladata: responseJson
				});
			}
		});
	}

	getdata() {
		$("#showLoader").show();
		GetData('group/getgroup').then((result) => {
			$("#showLoader").hide();
			let responseJson = result;
			if (responseJson) {
				this.setState({
					groups: responseJson
				});
			}
		});
	}

	/** get Academic Year **/
	getacyear() {

		GetData('academic/getacyear').then((result) => {
			let responseJson = result;
			if (responseJson) {
				this.setState({
					accyear: responseJson
				});
				var index = responseJson.findIndex(function (obj) {
					return (obj.iscurrent == 1);
				});
				var academic = $("#year").find("option:eq(1)").val();
				this.setState({
					acyear: responseJson[index].id
				});
				$('#year option').eq(index + 1).prop('selected', true).trigger('change');
			}
		});
	}

	//get allocate section details
	getallocatesection() {

		GetData('section/getsecbyacyear/' + this.state.acyear).then((result) => {
			let responseJson = result;
			if (responseJson) {
				this.setState({
					sections: responseJson
				});
			}
		});
	}

	getstudents() {
		$("#showLoader").show();
		GetData('group/getcurrentstudent/' + this.state.acyear + '/' + this.state.class + '/' + this.state.section).then((result) => {
			let responseJson = result;
			if (responseJson) {
				this.setState({
					students: responseJson
				});
			}
			$("#showLoader").hide();
		});
	}

	// Get Section By Class
	getsection(clas) {

		var dat = [];
		for (var i = 0; i < this.state.sections.length; i++) {

			if (this.state.sections[i].clas == clas) {
				dat.push(this.state.sections[i]);
			}
		}
		this.setState({ sec: dat });
	}

	viewClick(e) {

		this.setState({ view: 1 });
		if (this.state.type == 'student') {
			this.getstudents();
			this.getstudmember();
		}
		if (this.state.type == 'staff') {
			this.getemployee();
			this.getstaffmember();
		}
	}

	getemployee() {
		$("#showLoader").show();
		GetData('group/getemployee/' + this.state.department).then((result) => {
			let responseJson = result;
			if (responseJson) {
				this.setState({
					employee: responseJson
				});
			}
			$("#showLoader").hide();
		});
	}

	getstudmember() {

		GetData('group/getstudmember/' + this.state.acyear + '/' + this.state.class + '/' + this.state.section + '/' + this.state.group).then((result) => {
			let responseJson = result;
			if (responseJson) {
				this.setState({
					studmember: responseJson
				});
			}
		});
	}

	getstaffmember() {

		GetData('group/getstaffmember/' + this.state.department).then((result) => {
			let responseJson = result;
			if (responseJson) {
				this.setState({
					staffmember: responseJson
				});
			}
		});
	}

	checkmember(regno) {

		var index = this.state.studmember.findIndex(function (obj) {
			return (obj.student == regno);
		});
		if (index != -1) {
			return true;
		}
		else {
			return false;
		}
	}

	checkstaffmember(empcode) {
		var index = this.state.staffmember.findIndex(function (obj) {
			return (obj.employee == empcode);
		});
		if (index != -1) {
			return true;
		}
		else {
			return false;
		}
	}

	onView(e) {

		this.setState({ _redirect: true });
	}

	render() {

		if (this.state._redirect) {
			return (<Redirect to={'/group/summary'} />);
		}
		/** set Types select box **/
		this.types = [
			{ value: '', name: 'Select Type' },
			{ value: 'student', name: 'Student' },
			{ value: 'staff', name: 'Staff' },
		];
		var acyear = this.state.accyear;
		var clas = this.state.cladata;
		var sec = this.state.sec;
		var grp = this.state.groups;
		var dep = this.state.depart;

		if (this.state.type == 'student' && this.state.view == '1') {
			$("#showdata").show();
		}
		else {
			$("#showdata").hide();
		}
		if (this.state.type == 'staff' && this.state.view == '1') {
			$("#viewdata").show();
		}
		else {
			$("#viewdata").hide();
		}
		if (this.state.type == 'student' && this.state.class != '' && this.state.section != '') {
			this.state.viewbtn = false;
		}
		if (this.state.type == 'staff' && this.state.department != '') {
			this.state.viewbtn = false;
		}

		return (
			<div>
				{sessionStorage.getItem('userrole') == 'staff' ?
					<ManageStaffPage /> : <ManagePage />}
				<div className="animated fadeIn">
					<div className={this.state.alertClass}>
						{this.state._message}
					</div>
					<form action="" method="post" role="form" id="stcatform" encType="multipart/form-data" onSubmit={this.onSubmit} >
						<Row>
							<Col md="12">
								<Card>
									<CardHeader>Add Group Member&nbsp;&nbsp;&nbsp;&nbsp;
									Academic Year&nbsp;&nbsp;
						<select name="acyear" onChange={this.onChange} id="year">
											<option value="">Select Academic Year</option>
											{
												acyear.map(function (item) {
													return <option value={item.id}>{item.value}</option>;
												})
											}
										</select>
										<button type="button" size="sm" style={{ float: 'right' }} onClick={this.onView.bind(this)} className="btn btn-primary" >View</button>
									</CardHeader>
									<CardBody>
										<Row>
											<Col md="1">
												<FormGroup><Label>Group</Label></FormGroup>
											</Col>
											<Col md="2">
												<FormGroup>
													<select name="group" onChange={this.onChange} className="form-control" required value={this.state.group}>
														<option value="">Select Group</option>
														{
															grp.map(function (item) {
																return <option value={item.id}>{item.groupname}</option>;
															})
														}
													</select>
												</FormGroup>
											</Col>
											<Col md="1">
												<FormGroup><Label>Type</Label></FormGroup>
											</Col>
											<Col md="2">
												<FormGroup>
													<select name="type" id="type" onChange={this.onChange} className="form-control" required>
														{this.types.map((e, key) => {
															return <option key={key} value={e.value}>{e.name}</option>;
														})}
													</select>
												</FormGroup>
											</Col>
											{this.state.type == 'student' ?
												<Col md="1">
													<FormGroup><Label>Class</Label></FormGroup>
												</Col> : ''}
											{this.state.type == 'student' ?
												<Col md="2">
													<FormGroup>
														<select name="class" id="class" className="form-control" onChange={this.onClassChange} required>
															<option value="">Select Class</option>
															{
																clas.map(function (item) {
																	return <option value={item.id}>{item.class}</option>;
																})
															}
														</select>
													</FormGroup>
												</Col> : ''}
											{this.state.type == 'student' ?
												<Col md="1">
													<FormGroup><Label>Section</Label></FormGroup>
												</Col> : ''}
											{this.state.type == 'student' ?
												<Col md="1">
													<FormGroup>
														<select name="section" id="section" className="form-control" onChange={this.onSectionChange} required>
															<option value="">Select Section</option>
															{
																sec.map(function (item) {
																	return <option value={item.section}>{item.secs}</option>;
																})
															}
														</select>
													</FormGroup>
												</Col> : ''}
											{this.state.type == 'staff' ?
												<Col md="1">
													<FormGroup>
														<Label>Department</Label>
													</FormGroup>
												</Col> : ''}
											{this.state.type == 'staff' ?
												<Col md="2">
													<FormGroup>
														<select name="department" id="dep" className="form-control" onChange={this.onDepChange} required>
															<option value="">Select Department</option>
															<option value="all">All</option>
															{
																dep.map(function (item) {
																	return <option value={item.id}>{item.department}</option>;
																})
															}
														</select>
													</FormGroup>
												</Col> : ''}
											<Col md="1">
												<button type="button" disabled={this.state.viewbtn} onClick={this.viewClick.bind(this)} className="btn btn-primary" >View</button>
											</Col>
										</Row>
										<Row id="showdata">
											<Col md="12">
												<table width="100%" style={{ border: '1px solid black' }}>
													<thead>
														<tr>
															<th style={{ border: '1px solid black' }}><input type="checkbox" id="chkall" onChange={this.onChkAllChange.bind(this)} /></th>
															<th style={{ border: '1px solid black' }}>S.No</th>
															<th style={{ border: '1px solid black' }}>Register No</th>
															<th style={{ border: '1px solid black' }}>Student Name</th>
															<th style={{ border: '1px solid black' }}>Class</th>
															<th style={{ border: '1px solid black' }}>Section</th>
															<th style={{ border: '1px solid black' }}>Mobile</th>
														</tr>
													</thead>
													<tbody>
														{this.state.students.length > 0 ?
															this.state.students.map((item, i) =>
																<tr key={i} style={{ backgroundColor: this.checkmember(item.regno) == true ? '#f3d9d9' : '' }}>
																	<td style={{ border: '1px solid black' }}><input type="checkbox" disabled={this.checkmember(item.regno)} className={this.checkmember(item.regno) == true ? '' : "chk"} onChange={this.onChkChange.bind(this, item.regno)} /></td>
																	<td style={{ border: '1px solid black' }}>{i + 1}</td>
																	<td style={{ border: '1px solid black' }}>{item.regno}</td>
																	<td style={{ border: '1px solid black' }}>{item.stdname}</td>
																	<td style={{ border: '1px solid black' }}>{item.classname}</td>
																	<td style={{ border: '1px solid black' }}>{item.sectionname}</td>
																	<td style={{ border: '1px solid black' }}>{item.mobile}</td>
																</tr>
															) : ''}
													</tbody>
												</table>
											</Col>
											<Col md="12">
												<Button type="submit" color="success" style={{ float: 'right' }} ><i className="fa fa-dot-circle-o"></i> Save</Button>
											</Col>
										</Row>
										<Row id="viewdata">
											<Col md="12">
												<table width="100%" style={{ border: '1px solid black' }}>
													<thead>
														<tr>
															<th style={{ border: '1px solid black' }}><input type="checkbox" id="chkallstaff" onChange={this.onChkAllStaffChange.bind(this)} /></th>
															<th style={{ border: '1px solid black' }}>S.No</th>
															<th style={{ border: '1px solid black' }}>Emp Code</th>
															<th style={{ border: '1px solid black', textTransform: 'uppercase' }}>Employee Name</th>
															<th style={{ border: '1px solid black' }}>Department</th>
															<th style={{ border: '1px solid black' }}>Designation</th>
															<th style={{ border: '1px solid black' }}>Mobile</th>
														</tr>
													</thead>
													<tbody>
														{this.state.employee.length > 0 ?
															this.state.employee.map((item, i) =>
																<tr key={i} style={{ backgroundColor: this.checkstaffmember(item.empcode) == true ? '#f3d9d9' : '' }}>
																	<td style={{ border: '1px solid black' }}><input type="checkbox" disabled={this.checkstaffmember(item.empcode)} className={this.checkstaffmember(item.empcode) == true ? '' : "chkstaff"} onChange={this.onChkStaffChange.bind(this, item.empcode)} /></td>
																	<td style={{ border: '1px solid black' }}>{i + 1}</td>
																	<td style={{ border: '1px solid black' }}>{item.empcode}</td>
																	<td style={{ border: '1px solid black', textTransform: 'uppercase' }}>{item.empname}</td>
																	<td style={{ border: '1px solid black' }}>{item.departmentname}</td>
																	<td style={{ border: '1px solid black' }}>{item.designationname}</td>
																	<td style={{ border: '1px solid black' }}>{item.mobile}</td>
																</tr>
															) :
															<tr>
																<td colSpan="7"><center>No Members....</center></td>
															</tr>
														}
													</tbody>
												</table>
											</Col>
											<Col md="12">
												<Button type="submit" color="success" style={{ float: 'right' }} ><i className="fa fa-dot-circle-o"></i> Save</Button>
											</Col>
										</Row>
									</CardBody>
								</Card>
							</Col>
						</Row>
					</form>
				</div>
			</div>
		)
	}
}

export default AddGroupMember;


// WEBPACK FOOTER //
// ./src/group/AddGroupMember/AddGroupMember.js